import { GridItem } from '@approvalmax/ui/src/components';

import { messages } from './SchedulerDay.messages';

export const daysOfWeekItems = [
    {
        id: 'mon',
        name: messages.monday,
    },
    {
        id: 'tue',
        name: messages.tuesday,
    },
    {
        id: 'wed',
        name: messages.wednesday,
    },
    {
        id: 'thu',
        name: messages.thursday,
    },
    {
        id: 'fri',
        name: messages.friday,
    },
    {
        id: 'sat',
        name: messages.saturday,
    },
    {
        id: 'sun',
        name: messages.sunday,
    },
];

export const weekNumbersItems: GridItem[] = Array.from({ length: 5 }, (_, i) => ({
    id: (i + 1).toString(),
    name: (i + 1).toString(),
}));

export const daysItems: GridItem[] = Array.from({ length: 31 }, (_, i) => ({
    id: (i + 1).toString(),
    name: (i + 1).toString(),
}));
